import { pluralize } from '@/utils/string.utils'

/**
 * Ticket and timeslot selection (OrderItem, TimeOfDay, TimeSlot, Timeslots, CalendarHeader, LocalChecker)
 */
export const TICKET_SELECTION = {
  ticketsLeft: (remaining: number) => `${remaining} ${pluralize(remaining, 'ticket')} left`,
  saleEnds: 'Sale ends',
  onSale: 'Onsale',
  noLongerAvailable: 'No longer available',
  morning: 'Morning',
  afternoon: 'Afternoon',
  evening: 'Evening',
  unavailable: 'unavailable',
  remainingLeft: (remaining: number) => `${remaining} left`,
  or: 'or',
  notAvailableForDate: 'not available for this date',
  soldOutLower: 'sold out',
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  zipAccepted: 'Zip code accepted',
}

/**
 * Cart timer (Timer.tsx, Timer.utils.ts)
 */
export const TIMER = {
  minutesLeft: 'minutes left',
  toPurchase: 'to purchase your tickets',
  cartExpiresIn: (time: string, measurement: 'seconds' | 'minutes') => `Your cart will expire in ${time} ${measurement}`,
}

/**
 * Cart summary (SubtotalsList, LineItem, StickyMobileOrderFooter)
 */
export const CART_SUMMARY = {
  discounts: (count: number) => pluralize(count, 'Discount'),
  giftCards: (count: number) => pluralize(count, 'Gift Card'),
  quantity: (quantity: number) => `x ${quantity}`,
  goToEventDetails: 'Go to event details',
  price: 'Price',
}
